/* eslint-disable @typescript-eslint/naming-convention */
import type { GlobalData } from '@/interfaces/strapi';
import type { StrapiGlobalModel } from '@/interfaces/model/global.strapi.model';
import { assetsUrl } from '@/constants/strapi.constants';
import type { ImageModel } from '@/interfaces/model';
import type { Image } from '@/interfaces/strapi';

const mapImage = (img: ImageModel | null | undefined, fallbackAlt = ''): Image => ({
	url: img?.url ? `${assetsUrl}${img.url}` : '',
	alt: img?.alternativeText ?? fallbackAlt ?? '',
});

export const globalMapper = ({ header, body, footer, socialMedia }: StrapiGlobalModel): GlobalData => {
	const { logo, rightImage } = header;
	const { bgImage, has_searcher_escrituras_publicas, has_searcher_notarios, banner } = body;
	const { footerTop, footerBottom } = footer;
	const { title, quickAccess, map, legalText } = footerTop;

	const mappedBanners = banner.map((item) => ({
		active: item.is_active,
		name: item.name,
		url: item.linkUrl,
		image: `${assetsUrl}${item.image.url}`,
	}));

	const mappedQuickAccess = quickAccess.map((item) => ({
		text: item.text,
		url: item.url,
		icon: {
			url: `${assetsUrl}${item.icon.url}`,
			alt: item.icon.alternativeText ?? '',
		},
	}));

	const mappedLegalList = footerBottom.legalList.map((item) => ({
		id: item.id,
		text: item.text,
		url: item.url,
		icon: item.icon,
	}));

	const mappedAddressItem = footerTop.address.addressItem.map((item) => ({
		icon: item.icon,
		text: item.text,
	}));

	const mappedSocialMedia = socialMedia.map((s) => ({
		id: s.id,
		socialNetwork: s.socialNetwork,
		title: s.title,
		url: s.url,
		icon: mapImage(s.icon, s.title || s.socialNetwork),
	}));

	return {
		layout: {
			header: {
				logo: {
					alt: logo.alt,
					link: logo.url,
					imageUrl: `${assetsUrl}${logo.image.url}`,
				},
				image: `${assetsUrl}${rightImage.url}`,
			},
			body: {
				bgImage: `${assetsUrl}${bgImage.url}`,
				hasSearcherEscriturasPublicas: has_searcher_escrituras_publicas,
				hasSearcherNotarios: has_searcher_notarios,
				banners: mappedBanners,
			},
			footer: {
				top: {
					title,
					quickAccess: mappedQuickAccess,
				},
				middle: {
					map,
					legalText,
					address: {
						items: mappedAddressItem,
					},
					menu: [
						{
							label: 'El colegio',
							url: '/el-colegio',
						},
						{
							label: 'Actualidad',
							url: '/actualidad',
						},
					],
				},
				bottom: {
					copyright: footerBottom.text,
					legalList: mappedLegalList,
					ctLogo: mapImage(footerBottom.ctLogo, 'CT Notariado'),
				},
			},
		},
		socialMedia: mappedSocialMedia,
	};
};
